import type { UserDetail } from '../types/domain'
import { isLibertyRoleName } from './editPageUi'

export function isLibertyUser(user: UserDetail | null): boolean {
  if (user?.liberty_role != null) return Boolean(user.liberty_role)
  return user?.roles?.some((role) => isLibertyRoleName(role.role_name)) ?? false
}

export function buildNotificationActionDetails(user: UserDetail | null) {
  if (!user) {
    return { contract_refund_approval: false, contract_invoice_approval: false }
  }
  return {
    contract_refund_approval: (user.action_roles ?? []).some(
      (actionRole) =>
        actionRole.notification_name === 'contract_refund_approval' &&
        (user.roles ?? []).some((role) => (actionRole.roles ?? []).includes(role.role_name)),
    ),
    contract_invoice_approval: (user.action_roles ?? []).some(
      (actionRole) =>
        actionRole.notification_name === 'contract_invoice_approval' &&
        (user.roles ?? []).some((role) => (actionRole.roles ?? []).includes(role.role_name)),
    ),
  }
}

export function shouldShowNotificationSettings(user: UserDetail | null, isAdmin: boolean) {
  const actionDetails = buildNotificationActionDetails(user)
  return (
    isLibertyUser(user) &&
    isAdmin &&
    (actionDetails.contract_refund_approval || actionDetails.contract_invoice_approval)
  )
}
